import React from "react";
import styles from "./styles/footer.module.css";
import { Link, useNavigate } from "react-router-dom";
import { Socials } from "../Socials/Socials";
import { useAuth } from "../../Context/AuthContext";
import data from "../../data/multilanguage.json";
import { useState } from "react";
import { useContext } from "react";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import { GlobalOutlined, DownOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { Dropdown } from "antd";

import { Button } from "antd";

import { formattingRedirectionUrl } from "../../Utils/redirectingUrl";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

export function Footer() {
  const navigate = useNavigate();
  const auth = useAuth();

  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(websiteCurrentLang.content.footer);
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.footer);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const changeWebsiteLang = useContext(LanguageContext).changeWebsiteLanguage;
  const { height, width } = useWindowDimensions();
  const items = [
    {
      key: "1",
      label: (
        <div
          onClick={(e) => {
            changeWebsiteLang("fr");
          }}
          className={styles.languageWrapper}
        >
          <div className={styles.frenchLang}></div>
          <p>French</p>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div
          onClick={(e) => {
            changeWebsiteLang("en");
          }}
          className={styles.languageWrapper}
        >
          <div className={styles.USALang}></div>
          <p>English</p>
        </div>
      ),
    },
  ];
  return (
    <div className={styles.footer}>
      <div
        onClick={() => navigate("/user/dashboard", { replace: true })}
        className={styles.logo}
      />

      <Socials></Socials>
      <p className={styles.copyright}>{content.footerCopyright}</p>
      <div className={styles.links}>
        <div className={`${styles.list} ${styles.list_services}`}>
          <h2 className={styles.list_title}>{content.footerSubtitle1}</h2>
          <p className={styles.list_item}>
            <a
              rel="noreferrer"
              className={styles.list_item}
              href={dublicatedcontent?.intercom_how_it_works}
              target="_blank"
            >
              {dublicatedcontent.dublicatedText2}
            </a>
          </p>
          <p>
            {auth?.otp === true ? (
              <Link className={styles.list_item} to="/user/plan">
                {content.footerSubtitle1Link2}
              </Link>
            ) : (
              <a
                rel="noreferrer"
                className={styles.list_item}
                href={
                  window.location.pathname === "/"
                    ? "/#pricing"
                    : formattingRedirectionUrl("#pricing")
                }
                target={window.location.pathname === "/" ? "_self" : "_blank"}
              >
                {content.footerSubtitle1Link2}
              </a>
            )}
          </p>
          <p className={styles.list_item}>
            <a
              rel="noreferrer"
              className={styles.list_item}
              href={dublicatedcontent?.intercom_your_privacy}
              target="_blank"
            >
              {dublicatedcontent.dublicatedText36}
            </a>
          </p>
          <a
            rel="noreferrer"
            className={styles.list_item}
            href={dublicatedcontent?.intercom_security}
            target="_blank"
          >
            {content.footerSubtitle1Link4}
          </a>
        </div>
        <div className={`${styles.list} ${styles.list_company}`}>
          <h1 className={styles.list_title}>
            {dublicatedcontent.dublicatedText37}
          </h1>
          {/* <p className={styles.list_item} onClick={()=>navigate("/about-us")}>About Us</p> */}
          <p
            className={styles.list_item}
            onClick={() => {
              auth?.otp === true
                ? navigate("/user/terms-and-conditions", { replace: true })
                : (window.location.href = `${window.location.origin}/terms-and-conditions`);
            }}
          >
            {dublicatedcontent.dublicatedText38}
          </p>
          <p
            className={styles.list_item}
            onClick={() =>
              auth?.otp === true
                ? navigate("/user/privacy-policy", { replace: true })
                : (window.location.href = `${window.location.origin}/privacy-policy`)
            }
          >
            {dublicatedcontent.dublicatedText39}
          </p>
        </div>
        <div className={`${styles.list} ${styles.list_help}`}>
          <h1 className={styles.list_title}>
            {dublicatedcontent.dublicatedText40}
          </h1>
          <p
            className={styles.list_item}
            // onClick={() =>
            //   auth?.otp === true
            //     ? navigate("/user/contact-us")
            //     : navigate("/contact-us")
            // }
          >
            {auth?.otp === true ? (
              <Link to="/user/contact-us" className={styles.list_item}>
                {dublicatedcontent.dublicatedText35}
              </Link>
            ) : (
              <a
                rel="noreferrer"
                className={styles.list_item}
                href={`${window?.location?.protocol}//${window?.location?.host}/contact-us`}
                target="_blank"
              >
                {dublicatedcontent.dublicatedText35}
              </a>
            )}
          </p>
          <p className={styles.list_item}>
            <a
              rel="noreferrer"
              className={styles.list_item}
              href={dublicatedcontent?.intercom_main}
              target="_blank"
            >
              {dublicatedcontent.dublicatedText6}
            </a>
          </p>
          <p className={styles.list_item}>
            <a
              rel="noreferrer"
              className={styles.list_item}
              href={dublicatedcontent?.intercom_faqs}
              target="_blank"
            >
              {content.footerSubtitle3Link3}
            </a>
          </p>

          {/* <Dropdown
            className={styles.dropdown}
            menu={{ items }}
            placement="bottom"
            arrow
            overlayClassName={styles.y}
          >
            <Button>
              {websiteCurrentLang.label === "fr" ? "French" : "English"}
            </Button>
          </Dropdown> */}

          {width > 767 && (
            <Dropdown
              className={styles.dropdown}
              menu={{ items }}
              placement="bottom"
              arrow
              overlayClassName={styles.y}
            >
              <Button className={styles.lngButton}>
                <GlobalOutlined
                  style={{
                    margin: 0,
                    scale: "1.2",
                  }}
                />
                {websiteCurrentLang.label === "fr" ? (
                  <span
                    style={{
                      margin: 0,
                    }}
                  >
                    French
                  </span>
                ) : (
                  <span
                    style={{
                      margin: 0,
                    }}
                  >
                    English
                  </span>
                )}
                <DownOutlined
                  style={{
                    margin: 0,
                    scale: "1.2",
                  }}
                />
              </Button>
            </Dropdown>
          )}
        </div>
        {width <= 766 && (
          <Dropdown
            className={styles.dropdown}
            menu={{ items }}
            placement="bottom"
            arrow
            overlayClassName={styles.y}
          >
            <Button className={styles.lngButton}>
              <GlobalOutlined
                style={{
                  margin: 0,
                  scale: "1.2",
                }}
              />
              {websiteCurrentLang.label === "fr" ? (
                <span
                  style={{
                    margin: 0,
                  }}
                >
                  French
                </span>
              ) : (
                <span
                  style={{
                    margin: 0,
                  }}
                >
                  English
                </span>
              )}
              <DownOutlined
                style={{
                  margin: 0,
                  scale: "1.2",
                }}
              />
            </Button>
          </Dropdown>
        )}
      </div>
    </div>
  );
}
